import type { IconProps } from './IconsTypes'

export const ArrowVectorRight = ({
  width = 5,
  height = 18,
  viewBox = '0 0 5 8',
  color = '#000',
  className = '',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.53.47A.75.75 0 0 0 .47 1.53L1.53.47ZM4 4l.53.53a.75.75 0 0 0 0-1.06L4 4ZM.47 6.47a.75.75 0 0 0 1.06 1.06L.47 6.47Zm0-4.94 3 3 1.06-1.06-3-3L.47 1.53Zm3 1.94-3 3 1.06 1.06 3-3-1.06-1.06Z"
      fill={color}
    />
  </svg>
)
